import React, { useState } from "react";

const GiftListHelp = () => {
  const [showHelp, setShowHelp] = useState(false);

  return (
    <>
      <h5 className="pointer underline" onClick={() => setShowHelp(!showHelp)}>
        How it works?
      </h5>
      {showHelp && (
        <div className="padding-bottom-style"> 
        <p>
          Writing a Gift List is a fun Christmas tradition. A well written
          gift list can make your life easier.
          First of all you need to add as many persons as you want with the "Add Person" option.
          Then you can make a list of gifts individually that he/she gets for Christmas!
          </p>
        </div>
      )}
    </>
  );
};

export default GiftListHelp;
